import { MedicineAPI } from './types'
import { filterQueryParams, decamelizeKeys } from '@/utils'
import queryString from 'query-string'

export const medicineApi: MedicineAPI = ky => {
  return {
    async fetch(params) {
      const filteredParams = filterQueryParams(params || {})

      return await ky('medicine/', {
        method: 'get',
        searchParams: queryString.stringify(decamelizeKeys(filteredParams))
      }).json()
    },

    async fetchPage({ url }) {
      return await ky(url, {
        method: 'get'
      }).json()
    }
  }
}
